
import { Trans, useTranslation } from "react-i18next";

const UnknownUser = () => {
  const { t } = useTranslation();
  const lochallHomeUrl = String(t('externalUrls.lochall.home'));


  return (
    <div className="error-container" data-testid="unknown-user">
        <h1>{t('error.unknownUser')}</h1>
        <p>
          <Trans
            i18nKey="error.authenticateFirst"
            components={{
              lochallLink: <a href={lochallHomeUrl}>Loc'Hall</a>,
            }}
          />
        </p>
        <p>{t('error.seeYouSoon')}</p>
    </div>
  );
};

export default UnknownUser;
